import { createSelector } from '@ngrx/store'
import { AppState } from '../../../../store'

import { getUserState } from './user.selectors'

export const getAuthState = (state: AppState) => state.auth

export const getAuthLoggedIn = createSelector(
  getAuthState,
  getUserState,
  (authState, userState) => !!(authState.access_token && userState.user)
)




// WEBPACK FOOTER //
// ./src/app/shared/auth/store/selectors/auth.selectors.ts